import cn from 'classnames'
import qs from 'qs'
import React, { useEffect, useState } from 'react'
import { get } from '../helpers/Api'
import LoadingIndicator from '../loadingindicator'
import TradeItem from './TradeItem'
import { useSharedState } from '../waxplorer/Waxplorer'

const SentTrades = (props) => {
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const tabKey = props['tabKey']

    let values = qs.parse(
        window.location.search.substring(1, window.location.search.length),
    )

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : values['user']

    const [trades, setTrades] = useState(null)

    const loadReceivedTrades = async (userName) => {
        get(`get-sent-trade-offers/${userName}`).then((res) => {
            setTrades(res)
        })
    }

    useEffect(() => {
        if (tabKey === 'sent-offers' && userName) {
            loadReceivedTrades(userName)
        }
    }, [tabKey, userName])

    return trades ? (
        <div className={cn('w-full relative h-9/10')}>
            {trades.map((trade) => (
                <TradeItem trade={trade} />
            ))}
        </div>
    ) : (
        <LoadingIndicator />
    )
}

export default SentTrades
